import { useOrderBuyerCreateEntityData } from '@steelbuy/data-provider';
import { CheckoutIllustratedSuccess } from '@steelbuy/ui-domain';
import { useIsVendorFeatureSupported } from '@steelbuy/vendor';
import { CheckoutSuccessDynamicDelivery } from './CheckoutSuccessDynamicDelivery';
import { CheckoutSuccessWrapper } from './CheckoutSuccessWrapper';
import { RoutePath } from '../../router/Routes';

export const CheckoutSuccess = () => {
    const orderModel = useOrderBuyerCreateEntityData().query().get();
    const isDynamicDeliveryPriceEnabled = useIsVendorFeatureSupported('DYNAMIC_DELIVERY_PRICE');

    if (orderModel === null) {
        return null;
    }

    if (isDynamicDeliveryPriceEnabled) {
        return <CheckoutSuccessDynamicDelivery orderModel={orderModel} />;
    }

    return (
        <CheckoutSuccessWrapper>
            <CheckoutIllustratedSuccess orderModel={orderModel} myOrdersUrl={RoutePath.MY_ORDERS} />
        </CheckoutSuccessWrapper>
    );
};
